import {StyleSheet} from 'react-native';

import {chestnut, pineLight} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  icon: {
    fontSize: 10,
    marginRight: 4,
    marginTop: 1,
  },
  iconPositive: {
    color: pineLight,
  },
  iconNegative: {
    color: chestnut,
  },
  iconZero: {
    display: 'none',
  },
  text: {},
});
